export { rem } from '@mantine/core'